'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuStyled = undefined;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var Menu = _styledComponents2.default.nav.withConfig({
  displayName: 'MenuStyled__Menu'
})(['padding:0;margin:0;']);

var MenuDiv = Menu.withComponent('div'); // eslint-disable-next-line react/prop-types

var MenuStyled = function MenuStyled(_ref) {
  var wrapWithDiv = _ref.wrapWithDiv,
      props = _objectWithoutProperties(_ref, ['wrapWithDiv']);

  return wrapWithDiv ? _react2.default.createElement(MenuDiv, props) : _react2.default.createElement(Menu, props);
};

exports.MenuStyled = MenuStyled;
MenuStyled.displayName = 'MenuStyled';